<div *ngIf="checkTimeZoneOffsetDiff()"
     class="layout-row br-body-2"
     [ngClass]="{'md-tiny' : isSmall , 'layout-align-start-start': isColumn, 'layout-align-start-center': !isColumn}">

  <bringoz-icon iconName="time-zone" fill="#7E7E7E"
                [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover"></bringoz-icon>

  <ng-template #tooltipTmpl>
    <div class="layout-row layout-align-start-center gap-10">
      <span class="br-body-2 margin-right-5">{{timeZoneId}} ({{timeZoneOffsetDiff}}{{ 'hrs' | translate}}),</span>
      <span *ngIf="notBefore && notAfter" class="br-body-2">{{{
        notBefore: notBefore,
        notAfter: notAfter
      } | timeWindow: timeZoneId}}</span>
      <span *ngIf="notBefore && !notAfter"
            class="br-body-2">{{{eta: notBefore} | bringozDate: 'eta': true: timeZoneId}} |</span>
    </div>
  </ng-template>


  <div [ngClass]="{'layout-column': isColumn, 'layout-row': !isColumn}">
    <!--Time Window Display-->
    <span *ngIf="isShowTime && (notBefore && notAfter)"
          class="light-grey">{{{notBefore: notBefore, notAfter: notAfter} | timeWindow: timeZoneId}}
      | </span>
    <!--ETA Display-->
    <span *ngIf="isShowTime && (notBefore && !notAfter)"
          class="light-grey margin-right-5">{{{eta: notBefore} | bringozDate: 'eta': true: timeZoneId}}
      |</span>

    <span class="light-grey">{{timeZoneId}} ({{timeZoneOffsetDiff}}{{ 'hrs' | translate}})</span>
  </div>

</div>

